import { NgModule } from '@angular/core';
import { CommonModule } from '@angular/common';
import { RenewPasswordComponent } from './renew-password.component';
import { SharedModule } from '@app/shared/shared.module';
import { RouterModule } from '@angular/router';
import { SmashFormsModule } from '@app/shared/modules/smash-forms/smash-forms.module';



@NgModule({
  declarations: [
    RenewPasswordComponent,
  ],
  imports: [
    CommonModule,
    SharedModule,
    SmashFormsModule,
    RouterModule,
  ],
  exports: [
    RenewPasswordComponent
  ]
})
export class RenewPasswordModule { }
